import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'
import { Button } from '@structural-climbing/ui'
import { profileFixLink } from './profileFixLink'

interface Props {
  gymName: string
}

/**
 * Shown on a gym's screens to a member who joined before a phone number was
 * required, when that gym has asked for them to be gathered. It links straight
 * to the field and brings the member back to the screen they were on.
 */
export function PhoneNeededBanner({ gymName }: Props) {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  return (
    <div className="bg-[var(--gym-page)] px-4 pt-4">
      <div
        role="status"
        className="mx-auto w-full max-w-xl overflow-hidden rounded-2xl border border-divider bg-content1 shadow-sm"
      >
        <div className="flex flex-col gap-3 border-l-4 border-warning bg-warning/10 p-4 sm:flex-row sm:items-center">
          <p className="flex-1 text-sm font-medium">{t('profile.phoneBannerText', { gymName })}</p>
          <Button
            as={Link}
            to={profileFixLink('phone', pathname)}
            color="primary"
            variant="flat"
            className="shrink-0 font-semibold"
          >
            {t('profile.phoneBannerCta')}
          </Button>
        </div>
      </div>
    </div>
  )
}
